export default __webpack_public_path__ + "static/media/conversations-big-icon.510dcf7b.svg";